import { useMemo } from 'react';
import { GettextInterface } from '@indeed/indeed-gettext';
import { FeedbackCategory } from './types';
import useI18n from '../../../util/GettextFactory';

const createFeedbackCategories = (gt: GettextInterface): FeedbackCategory[] => [
    {
        id: 'JOB',
        title: gt.gettext('This job is inappropriate or misleading'),
        heading: gt.gettext('Please tell us what happened'),
        options: [
            gt.gettext("It's offensive, discriminatory"),
            gt.gettext('It seems like a fake job'),
            gt.gettext("It's inaccurate"),
            gt.gettext("It's an advertisement"),
            gt.gettext('Others'),
        ],
        allowMultiple: false,
    },
    {
        id: 'MATCHING',
        title: gt.gettext("This job doesn't match what I'm looking for"),
        heading: gt.gettext("Please tell us what didn't match"),
        options: [
            gt.gettext('Job title'),
            gt.gettext('Pay'),
            gt.gettext('Job type'),
            gt.gettext('Work schedule'),
            gt.gettext('Relocation'),
            gt.gettext('Work setting'),
            gt.gettext('Others'),
        ],
        allowMultiple: true,
    },
    {
        id: 'APPLY',
        title: gt.gettext('My application details are incorrect'),
        heading: gt.gettext('Please tell us what was inaccurate'),
        options: [
            gt.gettext('My contact information'),
            gt.gettext('My location'),
            gt.gettext('My resume'),
            gt.gettext("An answer to an employer's question"),
            gt.gettext('Others'),
        ],
        allowMultiple: true,
    },
    {
        id: 'OTHER',
        title: gt.gettext('Something else'),
        heading: gt.gettext('Please tell us what happened'),
        options: [],
        allowMultiple: false,
    },
];

export const useFeedbackCategories = (): FeedbackCategory[] => {
    const gt = useI18n();
    return useMemo(() => createFeedbackCategories(gt), [gt]);
};
